import { hasValue, isEmptyObject } from "utilities/common";

export const validateBox = (details) => {
    const myErrors = {}

    if (!details.name) {
        myErrors.name = 'Name is required'
    }
    if ((!details.productIds || !details.productIds?.length) && !details.isAllSelected) {
        myErrors.productIds = 'Select at least 1 product'
    }

    return { myErrors, isValid: isEmptyObject(myErrors) };
}

export const validateDistributionConfig = (details) => {
    const myErrors = {}

    if (details.minProductPerRegion && details.maxProductPerRegion < details.minProductPerRegion) {
        myErrors.maxProductPerRegion = 'Max product per region must be greater than min product per region'
    }
    if (details.minProductPerBox && details.maxProductPerBox < details.minProductPerBox) {
        myErrors.maxProductPerBox = 'Max product per box must be greater than min product per box'
    }
    if (details.minQuantityPerProduct && details.maxQuantityPerProduct < details.minQuantityPerProduct) {
        myErrors.maxQuantityPerProduct = 'Max product quantity must be greater than min product quantity'
    }

    return { myErrors, isValid: isEmptyObject(myErrors) };
}

export const validateRegionKit = (fields) => {
    const myErrors = {}

    if (!fields.regionId) {
        myErrors.regionId = 'Please select a region'
    }
    if (!fields.subRegionIds || fields.subRegionIds?.length === 0) {
        myErrors.subRegionIds = 'Please select sub region(s)'
    }

    return { myErrors, isValid: isEmptyObject(myErrors) };
}

export const validateKitProducts = (fields) => {
    const myErrors = [];
    const quantities = fields?.map((item => item.products))?.flat()

    quantities.map(product => {
        if (product?.minQuantity && product.maxQuantity && product.maxQuantity < product.minQuantity) {
            myErrors.push({ productId: product.productId, maxQuantity: 'Max quantity must be greater than min quantity' })
        }
    })

    const isValid = myErrors?.some(error => error.minQuantity || error.maxQuantity)

    return { myErrors, isValid: !isValid };
}

export const validateKitProductsBulkQty = (values) => {
    const myErrors = [];

    if (!values.minQuantity?.toString() && !values.maxQuantity) {
        myErrors.minQuantity = 'Min Quantity is required';
        myErrors.maxQuantity = 'Max Quantity is required';
    }
    if (values.maxQuantity === 0) {
        myErrors.maxQuantity = 'Max Quantity must be greater than 0';
    }
    if (values.minQuantity && values.maxQuantity && Number(values.minQuantity) > Number(values.maxQuantity)) {
        myErrors.minQuantity = 'Min Quantity should be less than Max Quantity';
    }

    const isValid = Object.values(myErrors).filter(Boolean).length > 0;

    return { myErrors, isValid: !isValid };
}

export function distributionBoxValidation(fields) {
    const errors = []

    fields.kits?.forEach((kit, idx) => {
        const myErrors = {}

        if (!kit.regionId) {
            myErrors.regionId = 'Please select a region'
        }
        if (!kit.subRegionId || !kit?.subRegionId?.length) {
            myErrors.subRegionId = 'Please select a sub region'
        }
        if (!kit.minProductPerRegion) {
            myErrors.minProductPerRegion = 'Please enter minimum product per region'
        }
        if (!kit.maxProductPerRegion) {
            myErrors.maxProductPerRegion = 'Please enter maximum product per region'
        }
        if (kit.minProductPerRegion && Number(kit.maxProductPerRegion) < Number(kit.minProductPerRegion)) {
            myErrors.maxProductPerRegion = 'Maximum product per region must be greater than minimum product'
        }

        if (!kit.boxes || !kit?.boxes?.length) {
            myErrors.boxesRequired = 'Select atleast one box'
        }

        myErrors.boxes = myErrors.boxes || [];

        for (const i in kit.boxes) {
            const box = kit.boxes[i]

            myErrors.boxes[i] = { ...(myErrors.boxes[i] || {}) };

            if (isNaN(box.minProductValuePerBox)) {
                myErrors.boxes[i].minProductValuePerBox = 'Invalid Value'
            }
            if (!box.minProductValuePerBox || box.minProductValuePerBox < 1) {
                myErrors.boxes[i].minProductValuePerBox = 'Please enter minimum product per region'
            }
            if (!box.maxProductValuePerBox) {
                myErrors.boxes[i].maxProductValuePerBox = 'Please enter maximum product per region'
            }
            if (box.minProductValuePerBox && Number(box.maxProductValuePerBox) < Number(box.minProductValuePerBox)) {
                myErrors.boxes[i].maxProductValuePerBox = 'Maximum product per region must be greater than minimum product'
            }
        }

        errors[idx] = myErrors;
    })



    return { myErrors: errors, isValid: !hasValue(errors) };
}

export const validateDistributionProduct = (details) => {
    const myErrors = {}

    if (!details.regionIds || !details.regionIds?.length) {
        myErrors.name = 'Region is required'
    }
    if (!details.boxId) {
        myErrors.boxId = 'Please select a box'
    }
    if (!details.productId) {
        myErrors.productId = 'Please select a product'
    }
    if (!details.driverIds || !details.driverIds?.length) {
        myErrors.driverIds = 'Please select a driver'
    }
    if (!details.qtyPerDriver) {
        myErrors.qtyPerDriver = 'Quantity per driver is required'
    }
    // if (details.availableQuantity < details.qtyPerDriver) {
    //     myErrors.qtyPerDriver = 'Quantity per driver must be less than available quantity'
    // }

    return { myErrors, isValid: isEmptyObject(myErrors) };
}

export const validateDriverDiscrepancy = (details) => {
    const myErrors = {}
    if (!details.discrepancyType) {
        myErrors.discrepancyType = 'Please select discrepancy'
    }
    if (!details.discrepancyBatches || !details?.discrepancyBatches?.length) {
        myErrors.discrepancyBatches = 'Please select batch'
    } else {
        myErrors.discrepancyBatches = [];
        details?.discrepancyBatches?.map((item) => {
            if (!item?.qty) {
                myErrors.discrepancyBatches.push({ batchNo: item.batchNo, error: 'Please enter quantity' })
            }
        })
    }

    if (myErrors.discrepancyBatches?.length === 0) {
        delete myErrors.discrepancyBatches
    }

    return { myErrors, isValid: isEmptyObject(myErrors) };
}

export const validateDriverClosureForm = (details) => {
    const myErrors = {}
    if (!details.closedNotes) {
        myErrors.closedNotes = 'Notes are required'
    }

    return { myErrors, isValid: isEmptyObject(myErrors) };
}
